"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useState } from "react";
type VotingModalOpenToken = Readonly<{
  readonly isVotingClosed: boolean;
}>;
interface VotingModalState {
  readonly isOpen: boolean;
  readonly open: () => void;
  readonly close: () => void;
}
export function useVotingModalState(isVotingClosed) {
  const $ = _c(9);
  let t0;
  if ($[0] !== isVotingClosed) {
    t0 = {
      isVotingClosed
    };
    $[0] = isVotingClosed;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentOpenToken = t0;
  const [openToken, setOpenToken] = useState(null);
  let t1;
  if ($[2] !== currentOpenToken || $[3] !== isVotingClosed) {
    t1 = () => {
      if (isVotingClosed) {
        return;
      }
      setOpenToken(currentOpenToken);
    };
    $[2] = currentOpenToken;
    $[3] = isVotingClosed;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const open = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOpenToken(null);
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const close = t2;
  const t3 = openToken === currentOpenToken && !isVotingClosed;
  let t4;
  if ($[6] !== open || $[7] !== t3) {
    t4 = {
      isOpen: t3,
      open,
      close
    };
    $[6] = open;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}